import { useState } from 'react';
import { deactivateAllFlowSnapshots } from '../../../sources/flow';
import translations from '../../../translations';
import ButtonPrimary from '../../buttons/ButtonPrimary';
import ConfirmModal from '../../generic/modal/ConfirmModal';
import { useNotificationDispatch } from '../../notifications/NotificationProvider';

interface Props {
    flowId: string;
    modalContainer: HTMLElement;
}

const Deactivation = ({ flowId, modalContainer }: Props) => {
    const [showDeactivateSnapshotConfirmation, setShowDeactivateSnapshotConfirmation] =
        useState(false);

    const dispatchNotification = useNotificationDispatch();

    const deactivateFlow = async () => {
        try {
            await deactivateAllFlowSnapshots(flowId);
            setShowDeactivateSnapshotConfirmation(false);
            dispatchNotification({
                type: 'notifySuccess',
                payload: {
                    message: translations.VERSION_SECTION_deactivate_all_snapshots_success,
                },
            });
        } catch (error) {
            dispatchNotification({
                type: 'notifyError',
                payload: {
                    error,
                },
            });
        }
    };

    return (
        <>
            <h2>Deactivation</h2>
            <span className="margin-bottom">
                {translations.VERSION_SECTION_deactivate_all_snapshots_environment_text}
            </span>
            <span>
                <ButtonPrimary
                    className="btn-danger"
                    title={translations.VERSION_SECTION_deactivate_flow_environment}
                    onClick={() => setShowDeactivateSnapshotConfirmation(true)}
                >
                    {translations.VERSION_SECTION_deactivate_flow_environment}
                </ButtonPrimary>
            </span>

            <ConfirmModal
                show={showDeactivateSnapshotConfirmation}
                title={translations.VERSION_SECTION_deactivate_all_snapshots}
                messages={[
                    translations.VERSION_SECTION_deactivate_all_snapshots_confirm_environments,
                ]}
                buttonStyle="danger"
                buttonCaption={translations.COMMON_confirm}
                onCancel={() => setShowDeactivateSnapshotConfirmation(false)}
                onConfirm={() => {
                    deactivateFlow();
                }}
                container={modalContainer}
            />
        </>
    );
};

export default Deactivation;
